import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSync,
  faCog,
  faCalendarAlt,
  faTimes,
  faPlus,
  faCopy,
  faUser,
  faPen,
  faCheck,
} from '@fortawesome/free-solid-svg-icons';

library.add(faSync);
library.add(faCog);
library.add(faCalendarAlt);
library.add(faTimes);
library.add(faPlus);
library.add(faCopy);
library.add(faUser);
library.add(faPen);
library.add(faCheck);



// WEBPACK FOOTER //
// ./src/icons.js